const calculateMonthlyPrincipalAndInterest = (
  loanAmount: number,
  monthlyInterestRate: number,
  loanTermMonths: number
) => {
  return (
    (loanAmount * monthlyInterestRate) / (1 - Math.pow(1 + monthlyInterestRate, -loanTermMonths))
  );
};

interface CalculateMortrageProps {
  homePrice: number;
  downPayment: number;
  loanTermYears: number;
  apr: number;
  propertyTaxAnnual: number;
  homeownersInsuranceMonthly: number;
  hoaFeesMonthly: number;
}
export function calculateMortgage({
  homePrice,
  downPayment,
  loanTermYears,
  apr,
  propertyTaxAnnual,
  homeownersInsuranceMonthly,
  hoaFeesMonthly = 0
}: CalculateMortrageProps): {
  monthlyPayment: number;
  mortgageSize: number;
  totalInterest: number;
  totalPaid: number;
  monthlyPropertyTaxes: number;
  monthlyPrincipalAndInterest: number;
} {
  const loanTermMonths = loanTermYears * 12;

  const loanAmount = homePrice - downPayment;

  const monthlyInterestRate = apr / 12 / 100;

  const monthlyPrincipalAndInterest = calculateMonthlyPrincipalAndInterest(
    loanAmount,
    monthlyInterestRate,
    loanTermMonths
  );

  const monthlyPropertyTaxes = propertyTaxAnnual / 12;

  const totalMonthlyPayment =
    monthlyPrincipalAndInterest +
    monthlyPropertyTaxes +
    homeownersInsuranceMonthly +
    hoaFeesMonthly;

  const totalPaid = totalMonthlyPayment * loanTermMonths;

  const totalInterest = totalPaid - loanAmount;

  return {
    monthlyPayment: parseFloat(totalMonthlyPayment.toFixed(2)),
    mortgageSize: loanAmount,
    totalInterest: parseFloat(totalInterest.toFixed(2)),
    totalPaid: parseFloat(totalPaid.toFixed(2)),
    monthlyPropertyTaxes,
    monthlyPrincipalAndInterest
  };
}
